import React, { useState } from "react";
import "./animate.css"
import axios from "axios";
import { useParams } from "react-router-dom";


const ResetPasword = () => {

    const [password,setPassword]=useState<string>("");
    const [confirmPassword,setConfirmPassword]=useState<string>("");
    const [message,setMessage]=useState<string>("");
    const [respText,setRespText]=useState<string>("");
    const {id} = useParams();

    //function to handle confirm password
    const handleConfirmPassword =(e:any)=>{
     
      setConfirmPassword(e.target.value);
      setMessage("");
     
    }

    const handleChangePassword =async ()=>{
         // Regular expressions for validation
         const hasNumeric = /\d/;
         const hasFiveAlphabets = /^(?=(?:.*[a-zA-Z]){5,})/;
 
         // Validate the fields
         if (password === '' || confirmPassword === '') {
             setMessage('Sorry, Password or Confirm Password cannot be empty. Please try again.');
             return;
         } else if (password.length < 5) {
             setMessage('Sorry, Minimum 5 characters required. Please try again.');
             return;
         } else if (!hasNumeric.test(password)) {
             setMessage('Sorry, Password must contain at least 1 numeric digit. Please try again.');
             return;
         } else if (!hasFiveAlphabets.test(password)) {
             setMessage('Sorry, Password must contain at least 5 alphabets. Please try again.');
             return;
         } else if (password !== confirmPassword) {
             setMessage('Passwords do not match. Please try again.');
             return;
         }else{
        const response = await axios.post("https:localhost:5001/ChangePassword/ChangePasswordResponse",{"Id":id,"Password":password});
        console.log("respnse",response);
      }
      debugger;
    }
  return (
    <div className="login_bg">
      <section className="login_section">
        <div className="container">
          <div className="row justify-content-center  col-lg-12">
            <div className="col-lg-5 center_mode">
              <div
                className="lhs_grid wow animate__animated animate__fadeInLeft"
                data-wow-duration="2s"
                data-wow-delay=".6s"
              >
                <h3>
                  Hello ! <br /> <span id="gm">Good Morning</span>
                </h3>
                <h4>
                  <span>Change/Reset</span> your password
                </h4>

                <div className="form-group" hidden>
                  <label
                    asp-for="LoginId"
                    className="control-label"
                    hidden
                  ></label>
                  <input
                    asp-for="LoginId"
                    className="form-control"
                    hidden
                    id="email"
                  />
                </div>

                <div className="form-group">
                  <label>
                    <img src="images/icons/006-key.png" />
                  </label>
                  <input
                    type="password"
                    id="Password"
                    name="new_pass"
                    value={password}
                    onChange={(e:any)=>setPassword(e.target.value)}
                    className="form-control"
                    placeholder="Enter your new password"
                  />
                </div>
                <div className="form-group">
                  <label>
                    <img src="images/icons/006-key.png" />
                  </label>
                  <input
                    type="password"
                    id="ConfirmPassword"
                    name="confirm_pass"
                    value={confirmPassword}
                    onChange={handleConfirmPassword}
                    className="form-control"
                    placeholder="Re-enter your new password"
                  />
                </div>
               <div className="text-center mt-2">
                  <p className="text-danger">{message?message:""}</p>
               </div>
               
                <div className="text-center">
                  <button type="button" id="submit" className="btn_login" onClick={handleChangePassword}>
                    <img src="images/icons/008-enter.png" /> Change Password
                  </button>
                </div>
                <div className="email_notify text-center mt-3" id="notif">
                  <i className="fa fa-check-circle-o"></i>
                  
                      <p >{respText?respText:""}</p>
               
                </div>
               
                <div className="apps_grid text-center mobile_apps_grid">
                  <p>Available on:</p>
                  <a href="https://play.google.com/store/apps/details?id=com.prosares.wow_mobile">
                    <img
                      className="android-img"
                      src="images/google-play-badge-en.png"
                      alt=""
                    />
                  </a>
                  <a href="https://apps.apple.com/us/app/prosares-wow/id1644326812">
                    <img
                      className="apple-img"
                      src="images/app_Store.png"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="rhs_grid wow animate__animated animate__fadeInRight"
                data-wow-duration="2s"
                data-wow-delay=".6s"
              >
                <div className="top_head text-center">
                  <img src="images/logo.png" alt="" className="pro-logo" />
                  <h3>
                    Welcome to <br /> <span>WOW Portal</span>
                  </h3>
                  <div className="apps_grid desktop_apps_grid">
                    <p>Available on:</p>
                    <a href="https://play.google.com/store/apps/details?id=com.prosares.wow_mobile">
                      <img
                        className="android-img"
                        src="images/google-play-badge-en.png"
                        alt=""
                      />
                    </a>
                    <a href="https://apps.apple.com/us/app/prosares-wow/id1644326812">
                      <img
                        className="apple-img"
                        src="images/app_Store.png"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPasword;
